import ExaminationTitle from './ExaminationTitle';

export default ExaminationTitle;
